// extracted by mini-css-extract-plugin
export var navBtn = "image-slider-simple-module--nav-btn--TljIP";
export var next = "image-slider-simple-module--next--HWwQG";
export var padlock = "image-slider-simple-module--padlock--zWLr7";
export var prev = "image-slider-simple-module--prev--liWyS";
export var slide = "image-slider-simple-module--slide--gb0DD";
export var sliderContainer = "image-slider-simple-module--slider-container--+WoDu";
export var sliderContent = "image-slider-simple-module--slider-content--dZEb8";